
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import listado from './lista-listado.vue';
import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
        }
    } )

    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }


        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }
        }

        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
           this.Controlador.Buscador.Filtros.Busqueda = this.Busqueda;
           this.Controlador.Buscador.Buscar( 1, false );
        }
    }
